import { ApiProperty } from "@nestjs/swagger";

export class LocationByIdDto{
    @ApiProperty()
    locationId:number;
}